import Vue from 'vue'
import Router from 'vue-router'
import authRouters from '@/modules/auth/router'
import adminRoutes from '@/modules/admin/router'
import compRouters from '@/modules/compras/router'
import rgfRouters from '@/modules/legislacao/router'
import homeRouters from '@/modules/home/router'
import socialRouters from '@/modules/social/router'
import sicRouters from '@/modules/sic/router'
import partidosRouters from '@/modules/gestao/router'
import noticiasRouters from '@/modules/noticias/router'
import legislativoRouters from '@/modules/legislativo/router'
import protocoRouters from '@/modules/protocolo/router'
import cadastroRouters from '@/modules/cadastros/router'
import servicoRouters from '@/modules/servicos/router'
import transparenciaRouters from '@/modules/transparencia/router'
import saudeRouters from '@/modules/saude/router'
import manutencaoRouters from '@/modules/manutencao/router'

import { baseApiUrl, userKey } from '@/global'
import axios from 'axios'

Vue.use(Router)

const routes = [
  ...authRouters,
  ...adminRoutes,
  ...compRouters,
  ...rgfRouters,
  ...homeRouters,
  ...socialRouters,
  ...sicRouters,
  ...partidosRouters,
  ...noticiasRouters,
  ...legislativoRouters,
  ...protocoRouters,
  ...cadastroRouters,
  ...servicoRouters,
  ...transparenciaRouters,
  ...saudeRouters,
  ...manutencaoRouters,
  // { path: '', redirect: '/auxilio', component: Auxilio }
  { path: '', redirect: '/' }
]

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})
router.beforeEach(async (to, from, next) => {
  const json = localStorage.getItem(userKey)
  const user = JSON.parse(json)
  //  const cam = to.matched[0].name
  //  const cam = to.matched[0].name
  if (!user) {
    next()
  } else {
    //   next({ path: '/' })

    if (to.matched.some(record => record.meta.acl)) {
      try {
        user.page = to.name
        const res = await axios.post(`${baseApiUrl}/minhas-permissoes`, user)
        user && res.data.acessar ? next() : next({ path: '/home' })
      } catch (error) {
        return next('/')
      }
    } else {
      next()
    }
  }
})

export default router
